const promiseMiddleware = (store) => (next) => (action) => {
    if (isPromise(action.payload)) {
        action.payload.then((res) => {
            action.payload = null
            action.payloadRes = res
            store.dispatch(action)
        })

        return
    }
    next(action)
}

function isPromise(v) {
    return v && typeof v.then === 'function'
}

export { promiseMiddleware }
